/**
 * On-pace indicator (2.6.3), two levels: frequency compliance this SOC-anchored
 * week; ordered visits at risk this 30-day period — the LUPA view, in clinical
 * framing. No dollars on a patient row.
 */
import { Chip, Stack, Tooltip } from "@mui/material";
import type { OnPace } from "../../engine/lupa";

const WEEK_LABEL: Record<OnPace["weekStatus"], { text: string; color: "success" | "warning" | "info" | "default" }> = {
  onPace: { text: "on pace", color: "success" },
  behind: { text: "behind", color: "warning" },
  ahead: { text: "ahead", color: "info" },
  quiet: { text: "quiet — transfer", color: "default" },
};
const PERIOD_LABEL: Record<OnPace["periodStatus"], { text: string; color: "success" | "warning" | "error" | "default" }> = {
  safe: { text: "safe", color: "success" },
  atRisk: { text: "at risk", color: "warning" },
  belowThreshold: { text: "below threshold", color: "error" },
  quiet: { text: "quiet — transfer", color: "default" },
};

export function OnPaceIndicator({ pace }: { pace: OnPace }) {
  const w = WEEK_LABEL[pace.weekStatus];
  const p = PERIOD_LABEL[pace.periodStatus];
  return (
    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
      <Tooltip title={`Week ${pace.weekIndex + 1} (${pace.weekStart} – ${pace.weekEnd}): ${pace.weekDone} delivered, ${pace.weekScheduled} scheduled, ${pace.weekMissed} missed of ${pace.weekOrdered} ordered`}>
        <Chip size="small" color={w.color} variant="outlined" label={`Week ${pace.weekIndex + 1}: ${pace.weekDone + pace.weekScheduled} of ${pace.weekOrdered} · ${w.text}`} />
      </Tooltip>
      <Tooltip title={`Period ${pace.period + 1} (${pace.periodStart} – ${pace.periodEnd}): ${pace.periodDone} delivered + ${pace.periodScheduled} scheduled vs threshold ${pace.lupaThreshold}; cushion ${pace.cushion}`}>
        <Chip size="small" color={p.color} variant="outlined" label={pace.periodStatus === "quiet" ? `Period ${pace.period + 1}: quiet` : pace.visitsAtRisk > 0 ? `Period ${pace.period + 1}: ${pace.visitsAtRisk} visit${pace.visitsAtRisk === 1 ? "" : "s"} at risk · ${p.text}` : `Period ${pace.period + 1}: cushion ${pace.cushion} · ${p.text}`} />
      </Tooltip>
    </Stack>
  );
}
